export const commonColors = {
  white: '#fff',
  black: '#000',
  offWhite: '#f0f0f0',
};

export const systemColors = {
  error: '#c23628',
  success: '#219653',
  info: '#479ccf',
  warning: '#f8e67e',
  positive: '#8de0a0',
  negative: '#feded0',
  neutral: '#fff6c3',
  unknown: '#efefef',
};

// TODO: remove export once integrated with main palette
export const brandColors = {
  blue: '#3094ed',
  aqua: '#0bdad2',
  lightAqua: '#a5fcec',
  purple: '#524fef',
  lightPurple: '#c3d4ff',
  neonGreen: '#b7ff5b',
  offWhite: '#f6f5f0',
};

//
export const legacyBrandColors = {
  darkBlue: '#29567a',
  offWhite: '#fafafc',
};

export const newSystemColors = {
  blue: {
    main: '#2A5CDB',
    dark: '#244EBA',
  },

  white: '#FFFFFF',
  gray6: '#F1F1F1',
  gray5: '#C6C6C6',
  gray4: '#AAAAAA',
  gray3: '#949494',
  gray2: '#666',
  gray1: '#333',
  navGray: '#191919',
};
